<template>
    <div class="tag-form">
        <div class="header">
            <h4 v-i18n="$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG?'ADD_CLIP':'ADD_TAG'" v-if="!tag.id"/>
            <h4 v-i18n="$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG?'UPDATE_CLIP':'UPDATE_TAG'" v-else/>
            <!-- <a href="javascript: void 0"  @click="cancel" class="close">
                <font-awesome-icon :icon="['fas','times']"/>
            </a> -->
        </div>
        <form ref="form">
            <div class="hg-label-w-input">
                <label v-i18n="$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG?'CLIP_TYPE':'TAG_TYPE'"/>
                <v-select   :options="tagTypes" v-model="tag.id_tag_type" class="hg-select tag-select"
                            :searchable="false" :filterable="false" :clearable="false" :reduce="t => t.id">
                    <template slot="selected-option" slot-scope="option">
                        <div class="tag-item">
                            <div class="tag-icon">
                                <img :src="option.icon" />
                            </div>
                            <div class="tag-body">
                                <span class="tag-type" v-i18n="option.name[$hisport.current_culture]"></span>
                                <small v-if="sports.length>1" v-i18n="$hisport.getSportName(option.id_sport)"></small>
                            </div>
                        </div>
                    </template>
                    <template slot="option" slot-scope="option">
                        <div class="tag-item">
                            <div class="tag-icon">
                                <img :src="option.icon" />
                            </div>
                            <div class="tag-body">
                                <span class="tag-type" v-i18n="option.name[$hisport.current_culture]"></span>
                                <small v-if="sports.length>1" v-i18n="$hisport.getSportName(option.id_sport)"></small>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>
            <div class="hg-label-w-input">
                <label v-i18n="$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG?'CLIP_START_TIME':'TAG_START_TIME'"/>
                <input  id="start_time" ref="start_time" 
                        :value="$options.filters.sec2time(tag.start_time, true)" 
                        @input="parseTime($event.target, tag, 'start_time')"
                        type="text" 
                        pattern="[0-9]{2}:[0-9]{2}:[0-9]{2}" 
                        class="hg-input" 
                        required v-validate/>
            </div>
            <div class="hg-label-w-input">
                <label v-i18n="$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG?'CLIP_END_TIME':'TAG_END_TIME'"/>
                <input  id="end_time" ref="end_time" 
                        :value="$options.filters.sec2time(tag.end_time, true)" 
                        @input="parseTime($event.target, tag, 'end_time')"
                        type="text" 
                        pattern="[0-9]{2}:[0-9]{2}:[0-9]{2}" 
                        class="hg-input" 
                        required v-validate/>
            </div>
            <div class="hg-label-w-input">
                <label v-i18n="$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG?'CLIP_VISIBILITY':'TAG_VISIBILITY'"/>
                <v-select   :options="visibilities" v-model="tag.visibility" class="hg-select"
                            :searchable="false" :filterable="false" :clearable="false" :reduce="v => v.id">
                    <template slot="selected-option" slot-scope="option">
                        <span v-i18n="'VISIBILITY_' + option.label"/>
                    </template>
                    <template slot="option" slot-scope="option">
                        <span v-i18n="'VISIBILITY_' + option.label"/>
                    </template>
                </v-select>
            </div>
            <div class="hg-label-w-input" v-if="mentionableUsers.length>0">
                <label v-i18n="$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG?'CLIP_USER_IDS':'TAG_USER_IDS'"/>
                <select-entity v-model="tag.mentions" :entityType="$hisport.entity_types.USER" :filterBy="{id: { $in: mentionableUsers.map(x=>x.id) } }"/>
            </div>
            <div class="hg-label-w-input">
                <label v-i18n="$hisport.options.platform.CONFIGURATION.AUTO_GENERATE_CLIPS_BY_TAG?'CLIP_DESCRIPTION':'TAG_DESCRIPTION'"/>
                <textarea id="description" ref="description" v-model="tag.description" class="hg-input">
                </textarea>
            </div>
        </form>
        <button class="hg-input btn-primary pull-right" @click="add" v-i18n="'ADD'" v-if="!tag.id"></button>
        <button class="hg-input btn-primary pull-right" @click="update" v-i18n="'UPDATE'" v-else></button>
        
        <button class="hg-input btn-abort pull-left" @click="cancel" v-i18n="'ABORT'"></button>
        <!-- <textarea :value="JSON.stringify(tag,null,2)"/> -->
    </div>
</template>

<script>
import selectEntity from "./select_entity"
export default {
    props: {
        mentionableUsers: {
            type: Array,
            default: function(){ return [] }
        },
        event: {
            type: Object,
            default: null
        },
        tagTypes: {
            type: Array,
            default: function(){
                return [];
            }
        },
        tag: {
            type: Object,
            default: function(){
                return {
                    id_tag_type:        undefined,
                    start_time:         0, 
                    end_time:           0,
                    id_creator:         null,
                    visibility:         this.$hisport.visibility_types.PRIVATE,
                    visibility_custom:  null,
                    description:        "",
                    mentions:           []
                }
            }
        },
        onTagAdd: {
            type: Function
        },
        onTagUpdate: {
            type: Function
        },
        onCancel: {
            type: Function
        }
    },
    components:{
        selectEntity
    },
    data(){
        return {
            sports: []
        }
    },
    mounted(){
        this.sports = this.tagTypes.reduce(function(acc, x){
            if(acc.indexOf(x.id_sport)<0) acc.push(x.id_sport);
            return acc;
        }, []);
    },
    computed:{
        visibilities: function(){
            return [
                {id: this.$hisport.visibility_types.PUBLIC, label: this.$hisport.getVisibilityName(this.$hisport.visibility_types.PUBLIC)},
                {id: this.$hisport.visibility_types.PRIVATE, label: this.$hisport.getVisibilityName(this.$hisport.visibility_types.PRIVATE)},
                {id: this.$hisport.visibility_types.ALL_CLUB, label: this.$hisport.getVisibilityName(this.$hisport.visibility_types.ALL_CLUB, this.event)}
            ]
        }
    },
    methods:{
        add: function(){
            if(this.$refs.form.checkValidity())
                this.onTagAdd(this.tag);
        },
        update: function(){
            if(this.$refs.form.checkValidity())
                this.onTagUpdate(this.tag);
        },
        cancel: function(){
            this.onCancel();
        },
        parseTime: function(inp, obj, f){
            if(inp.validity && !inp.validity.valid)
                return;
            try{
                var value = this.$hisport.options.helpers.time2sec(inp.value); 
                if(!isNaN(value)){
                    obj[f] = value;
                }
            }catch(ex){
                console.error("parseTime error:", ex)
            }
        }
    }
}
</script>
<style>
/* .tag-form{
    overflow-x: hidden;
    overflow-y: auto;
    height:100%;
    padding:5px 20px;
} */
/* .tag-form .header{
    display:flex;
    flex-direction: row;
    xpadding:20px 5px 10px 5px;
    height:40px;
}
.tag-form .header h4{
    margin:0;
    flex: 1 1 auto;
    padding:0;
} */
.tag-form .hg-label-w-input{
    display:flex;
    flex-direction: column;
    text-align:left;
}
.tag-form form{width:100%;}
.tag-form .bubble{
    position:absolute;
    left:70%;
    margin-top:10px;
    display:none!important;
}
.tag-form .user-select,
.tag-form .tag-select{position:relative;}
.tag-form .user-item,
.tag-form .tag-item{display:flex}
/* .tag-form .tag-item, */
.tag-form .user-item{padding:4px 0 0 0;align-content: center; align-self: center;}
.tag-form .user-item img{border-radius: var(--border-radius);width:32px;height:32px;padding:5px;margin-right:0px}
.tag-form .tag-item img{background:var(--violet);border-radius: var(--border-radius);width:32px;height:32px;padding:5px;margin-right:10px;} 
.tag-form .user-item .user-body,
.tag-form .tag-item .tag-body span{font-size:12px;font-weight:normal;color:#444;}
.tag-form .tag-item .tag-body small{font-size:10px;font-weight:normal;color:#999;} 
.tag-form .tag-item .tag-body{display:flex; flex-direction: column;line-height:18px;}
.tag-form .user-item .user-body{padding: 9px 0 0 0;}
.tag-form .user-select .vs__deselect{
    margin-right:5px;
}
.tag-form .user-select,
.tag-form .user-select .vs__dropdown-toggle{
    min-height:42px;
}
.tag-form .tag-select,
.tag-form .tag-select .vs__dropdown-toggle{
  height:42px;
  max-height:42px;
  min-height:42px;
}
.tag-form .tag-select .vs__search{
  display: none;
}
.tag-form .tag-select,
.tag-form .tag-select .vs__selected{
  width: 100%;
}
.tag-form .tag-select .vs__selected{
  border:0px;
  margin:0;
}
.tag-form .user-select,
.tag-form .user-select .vs__dropdown-toggle,
.tag-form .user-select .vs__selected-options,
.tag-form .user-select .vs__selected,
.tag-form .tag-select,
.tag-form .tag-select .vs__dropdown-toggle,
.tag-form .tag-select .vs__selected-options,
.tag-form .tag-select .vs__selected{
  padding: 0;
}
.tag-form .user-select .vs__dropdown-option,
.tag-form .tag-select .vs__dropdown-option{
  padding:0;
}
.tag-form .user-select .vs__selected-options{
    flex-wrap: wrap;
    padding: 0 0 5px;
}
.tag-form .user-select .vs__selected{
    max-height:32px;
}
.tag-form .v-select.hg-select .vs__dropdown-toggle{
    height: auto;
}
.tag-form .tag-item{
  padding:0;
  color: #666;
  font-weight:bold;
  display:flex;
  flex-direction: row;
  width: 100%;
  padding:4px;
  line-height: 32px;
}
.tag-form .user-select .vs__dropdown-toggle,
.tag-form .tag-select .vs__dropdown-toggle{
  background: rgba(255,255,255,.9);
  border: 1px solid rgba(60,60,60,.26);
  border-radius: 4px;
  color: #666;
}
</style>